import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "products",
  class: "bg-white"
}
const _hoisted_2 = { class: "text-black relative bg-white" }
const _hoisted_3 = { class: "border-t border-b border-gray-200 sticky top-16 lg:top-[92px] py-1 sm:py-2 bg-white" }
const _hoisted_4 = { class: "flex gap-1 lg:gap-6 px-1 lg:px-4 z-40 max-w-screen-xl mx-auto justify-center items-end" }
const _hoisted_5 = ["id", "onClick"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "font-light text-lg sm:font-bold absolute bottom-0 text-white inset-x-0 bg-gradient-to-b from-transparent to-black/50 pt-10" }
const _hoisted_8 = {
  id: "productsContainer",
  class: "max-w-screen-xl mx-auto"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_category = _resolveComponent("category")
  const _component_cart = _resolveComponent("cart")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Productos "),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("section", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.categories, (category) => {
              return (_openBlock(), _createElementBlock("button", {
                key: category.id,
                id: category.id,
                class: _normalizeClass(["border-2 border-transparent hover:border-white hover:bg-black/15 rounded-md overflow-hidden text-center bg-white relative", 'category-' + category.id === $data.selectedCategory  ? 'bg-slate-50/15': '']),
                onClick: $event => ($options.scrollToCategory(category.id))
              }, [
                _createElementVNode("img", {
                  src: category.image,
                  alt: category.name,
                  class: "object-cover",
                  style: {"width":"100px","height":"100px"}
                }, null, 8 /* PROPS */, _hoisted_6),
                _createElementVNode("h3", _hoisted_7, _toDisplayString(category.name), 1 /* TEXT */)
              ], 10 /* CLASS, PROPS */, _hoisted_5))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        _createElementVNode("section", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.categories, (category) => {
            return (_openBlock(), _createBlock(_component_category, {
              key: category.id,
              global: $props.global,
              category: category
            }, null, 8 /* PROPS */, ["global", "category"]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ]),
    _createVNode(_component_cart, { cart: _ctx.cart }, null, 8 /* PROPS */, ["cart"])
  ], 64 /* STABLE_FRAGMENT */))
}